import axios from "axios";
import { decryptData, encryptData } from "./utility-functions";

export const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? '/customer-ui-ms'
  : window.location.origin + '/customer-ui-ms';

async function makeRequest(
  endpoint,
  queryParams = {},
  method = "get",
  data = null,
  bypassEncryption = false
) {
  // if (sessionStorage.getItem("userStatus") === "warned") return;

  // Manually construct the query parameter string
  const queryString = Object.keys(queryParams)
    .map((key) => {
      if (Array.isArray(queryParams[key])) {
        // If the value is an array, join its elements using commas
        return `${key}=${queryParams[key].join(",")}`;
      } else {
        return `${key}=${encodeURIComponent(queryParams[key])}`;
      }
    })
    .join("&");

  const url = `${API_BASE_URL}/${endpoint}?${queryString}`;

  try {
    let processedData = data;

    if (!bypassEncryption) {
      processedData = await encryptData(data);
      console.log(processedData, "processedDataDebugger");
    }
    console.log(processedData, "encryptDataDebugger processedData 1");

    const response = await axios.request({
      method,
      url,
      headers: {
        Authorization: sessionStorage.getItem("BasicToken"),
        "Content-Type": "application/json",
      },
      data: processedData,
    });

    if (response.status === 200 || response.status === 201) {
      // Decrypt the response data unless it's the payments endpoint
      const decryptedResponse = await decryptData(response.data);
      // return decryptedResponse;
      let parsedResponse;
      if (typeof decryptedResponse === "string") {
        try {
          parsedResponse = JSON.parse(decryptedResponse); // Convert to JSON if it's a string
        } catch (error) {
          console.error("Failed to parse decrypted string as JSON:", error);
          parsedResponse = decryptedResponse; // Keep it as a string if parsing fails
        }
      } else {
        parsedResponse = decryptedResponse; // Already a JSON object
      }

      return parsedResponse;
    }

    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      sessionStorage.setItem("Error_401", true);
      console.error(error);
      if (sessionStorage.getItem("userStatus") === "notWarned") {
        sessionStorage.setItem("userStatus", "warned");
      } else {
        // setTimeout(() => window.location.reload(), 1000);
      }
    }
    throw error;
  }
}

// ============================================
// New Architecture Implementations
// ============================================

/**
 * Authenticates a staff member and returns their access token and information
 * @param {Object} credentials - The login credentials
 * @param {string} credentials.email - Staff member's email
 * @param {string} credentials.password - Staff member's password
 * @returns {Promise<Object>} The login response containing access token and staff information
 */
export const staffLogin = async ({ email, password }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/v1/staff/login`, {
      email,
      password
    });

    if (response.data.statusCode === "SUCCESS") {
      // Store the access token in sessionStorage
      sessionStorage.setItem("access_token", response.data.response.access_token);
      
      // Store staff information
      sessionStorage.setItem("staff_info", JSON.stringify(response.data.response.staff));
      
      // Store token expiration time
      const expiresAt = Date.now() + (response.data.response.expires_in * 1000);
      sessionStorage.setItem("token_expires_at", expiresAt.toString());
    }

    return response.data;
  } catch (error) {
    console.error("Error in staffLogin:", error);
    throw error;
  }
};

// ============================================
// Existing API functions
// ============================================

// DEPRECATED: Use getCallsList from apiClient.js instead
// export const getDistinctPatientsData = async (
//   search_key,
//   search_value,
//   batchRequestDocumentId,
//   emailId,
//   currentSessionId
// ) => {
//   try {
//     return await makeRequest("get_distinct_patients_data", {
//       search_key,
//       search_value,
//       batchRequestDocumentId,
//       emailId,
//       currentSessionId,
//     });
//   } catch (error) {
//     // Handle error as needed
//     console.error("Error in getDistinctPatientsDataa:", error);
//     throw error; // Re-throw the error to be handled at a higher level
//   }
// };

// DEPRECATED: Use getCallsList from apiClient.js instead
// export const getPatientsCallData = async (
//   emailId,
//   currentSessionId,
//   batchRequestDocumentId,
//   page_no,
//   page_size,
//   memberId,
//   sortBy,
//   sortType
// ) => {
//   try {
//     // Manually construct the filter_columns parameter as a single string
//     const filter_columns =
//       "['call_id','call_start_time','call_end_time','caller_handler.caller_handler_type','member_id','payload']";

//     // Create the request parameters object
//     const requestParams = {
//       // filter_columns,
//       emailId,
//       currentSessionId,
//       page_no,
//       page_size,
//       sort_by: sortBy,
//       order_type: sortType,
//     };

//     if (memberId) {
//       requestParams.memberId = memberId;
//     }

//     // Conditionally add batchRequestDocumentId to the request parameters
//     if (batchRequestDocumentId) {
//       requestParams.batchRequestDocumentId = batchRequestDocumentId;
//     }

//     return await makeRequest("get_patients_metadata", requestParams);
//   } catch (error) {
//     console.error("Error in getPatientsCallData:", error);
//     throw error;
//   }
// };

export const getPatientsCallDataPDF = async (
  emailId,
  currentSessionId,
  pdf_uri
) => {
  try {
    // Create the request parameters object
    const requestParams = {
      pdf_uri,
      emailId,
      currentSessionId,
    };

    return await makeRequest("get_patients_metadata", requestParams);
  } catch (error) {
    console.error("Error in getPatientsCallDataPDF:", error);
    throw error;
  }
};

// DEPRECATED: Use getCallsList from apiClient.js instead
// export const getPatientsCallDataOld = async (
//   memberId,
//   emailId,
//   currentSessionId,
//   batchRequestDocumentId
// ) => {
//   try {
//     // Manually construct the filter_columns parameter as a single string
//     const filter_columns =
//       "['call_id','call_start_time','call_end_time','caller_handler.caller_handler_type','member_id','payload']";

//     // Create the request parameters object
//     const requestParams = {
//       filter_columns,
//       emailId,
//       currentSessionId,
//     };

//     // Conditionally add batchRequestDocumentId to the request parameters
//     if (memberId) {
//       requestParams.memberId = memberId;
//     }
//     if (batchRequestDocumentId) {
//       requestParams.batchRequestDocumentId = batchRequestDocumentId;
//     }

//     return await makeRequest("get_patients_metadata", requestParams);
//   } catch (error) {
//     console.error("Error in getPatientsCallData:", error);
//     throw error;
//   }
// };

// DEPRECATED: Use getCallRequest from apiClient.js instead
// export const getCallHistory = (call_id, emailId, currentSessionId) => {
//   try {
//     const call_columns =
//       "['call_duration', 'white_sheet','call_transcription_fragment','call_start_time','call_end_time','call_id','batch_request_document_id','call_audio_url', 'overall_call_metadata']";
//     return makeRequest("get_call_history", {
//       call_columns,
//       call_id,
//       emailId,
//       currentSessionId,
//     });
//   } catch (error) {
//     console.error("Error in getCallHistory:", error);
//     throw error;
//   }
// };

export const getBatchStatus = (
  emailId,
  currentSessionId,
  batch_request_document_id
) => {
  try {
    return makeRequest("get_batch_status", {
      emailId,
      currentSessionId,
      batch_request_document_id,
    });
  } catch (error) {
    console.error("Error in getCallHistory:", error);
    throw error;
  }
};

export const getCallAndProcessData = async (
  emailId,
  currentSessionId,
  batch_request_id
) => {
  try {
    return await makeRequest("get_call_and_process_data", {
      emailId,
      currentSessionId,
      batchRequestDocumentId: batch_request_id,
    });
  } catch (error) {
    console.error("Error in getCallAndProcessData:", error);
    throw error;
  }
};

export const getErrorData = async (
  batch_request_id,
  emailId,
  currentSessionId
) => {
  try {
    return await makeRequest("get_error_data", {
      batch_request_id,
      emailId,
      currentSessionId,
    });
  } catch (error) {
    console.error("Error in getErrorData:", error);
    throw error;
  }
};

export const getProviderData = async (emailId, currentSessionId) => {
  try {
    return await makeRequest("get_provider_metadata", {
      emailId,
      currentSessionId,
    });
  } catch (error) {
    console.error("Error in getProviderData:", error);
    throw error;
  }
};

export const getBatchData = async (providerId, emailId, currentSessionId) => {
  try {
    return await makeRequest("get_batch_data", {
      providerId,
      emailId,
      currentSessionId,
    });
  } catch (error) {
    console.error("Error in getCustomerData:", error);
    throw error;
  }
};

export const getBatchDataCSV = async (csv_uri, emailId, currentSessionId) => {
  try {
    const response = await makeRequest("get_batch_data", {
      csv_uri,
      emailId,
      currentSessionId,
    });
    return response.csv_data;
  } catch (error) {
    console.error("Error in getCustomerData:", error);
    throw error;
  }
};

export const getHomePageDownloadData = async (
  providerId,
  emailId,
  currentSessionId,
  call_post_process_data,
  batch_request_id
) => {
  try {
    return await makeRequest("get_batch_data", {
      providerId,
      emailId,
      currentSessionId,
      call_post_process_data,
      batch_request_id,
    });
  } catch (error) {
    console.error("Error in getCustomerData:", error);
    throw error;
  }
};

export const insertUserActivity = async (
  emailId,
  activityType,
  forceFlag,
  sessionId
) => {
  try {
    return;
    return await makeRequest(
      "insert_user_activity",
      { emailId, activityType, forceFlag, sessionId },
      "post",
      {},
      true
    );
  } catch (error) {
    console.error("Error in insertUserActivity:", error);
    throw error;
  }
};

export const pushProviderPayorData = async (
  requestData,
  emailId,
  currentSessionId
) => {
  try {
    return await makeRequest(
      "push_provider_payor_data",
      {
        emailId,
        currentSessionId,
        provider_email: sessionStorage.getItem("providerEmail"),
      },
      "post",
      JSON.stringify(requestData)
    );
  } catch (error) {
    console.error("Error in pushProviderPayorData:", error);
    throw error;
  }
};

export const pushProviderPatientData = async (
  requestData,
  emailId,
  currentSessionId,
  batch_request_id,
  branch,
  usecaseName,
  subUsecaseName
) => {
  try {
    return await makeRequest(
      "push_provider_patient_data",
      {
        emailId,
        currentSessionId,
        batch_request_id,
        provider_email: sessionStorage.getItem("providerEmail"),
        branch,
        usecaseName,
        subUsecaseName
      },
      "post",
      JSON.stringify(requestData),
      true
    );
  } catch (error) {
    console.error("Error in pushProviderPatientData:", error);
    throw error;
  }
};

export const pushDataToFileBucket = async (
  requestData,
  emailId,
  currentSessionId,
  batch_request_id
) => {
  try {
    // Construct the request parameters
    const requestParams = { emailId, currentSessionId, batch_request_id };

    // Use the makeRequest function for the POST request and encrypt data
    return await makeRequest(
      "push_file_to_bucket", // endpoint
      requestParams, // query params
      "post", // method
      requestData // data (body)
    );
  } catch (error) {
    console.error("Error in pushDataToFileBucket:", error);
    throw error;
  }
};

export const getCustomerUiRbca = async (role, emailId, currentSessionId) => {
  try {
    return await makeRequest("get_customer_ui_rbca", {
      role,
      emailId,
      currentSessionId,
    });
  } catch (error) {
    console.error("Error in getCustomerUiRbca:", error);
    throw error;
  }
};

export const getAllCustomerUiRbca = async (emailId, currentSessionId) => {
  try {
    return await makeRequest("get_customer_ui_rbca", {
      emailId,
      currentSessionId,
    });
  } catch (error) {
    console.error("Error in getCustomerUiRbca:", error);
    throw error;
  }
};

export const addUserRole = async (requestData, emailId, currentSessionId) => {
  try {
    // Construct the request parameters
    const requestParams = { emailId, currentSessionId };

    // Use the makeRequest function for the POST request and encrypt data
    return await makeRequest(
      "post_customer_ui_rbca", // endpoint
      requestParams, // query params
      "post", // method
      requestData // data (body)
    );
  } catch (error) {
    console.error("Error in addUserRole:", error);
    throw error;
  }
};

export const updateUserRole = async (
  requestData,
  emailId,
  currentSessionId
) => {
  try {
    // Construct the request parameters
    const requestParams = { emailId, currentSessionId };

    // Use the makeRequest function for the PUT request
    return await makeRequest(
      "update_customer_ui_rbca", // endpoint
      requestParams, // query params
      "put", // method
      requestData // data (body)
    );
  } catch (error) {
    console.error("Error in updateUserRole:", error);
    throw error;
  }
};

export const deleteUserRole = async (
  requestData,
  emailId,
  currentSessionId
) => {
  try {
    // Construct the request parameters
    const requestParams = { emailId, currentSessionId };

    // Use the makeRequest function for the DELETE request
    return await makeRequest(
      "delete_customer_ui_rbca", // endpoint
      requestParams, // query params
      "delete", // method
      requestData // data (body)
    );
  } catch (error) {
    console.error("Error in deleteUserRole:", error);
    throw error;
  }
};

// DEPRECATED: Use getCallAudio from apiClient.js instead
// export const getCallAUDIO = async (audio_url, emailId, currentSessionId) => {
//   if (audio_url) {
//     try {
//       // Construct the request params
//       const requestParams = {
//         emailId,
//         currentSessionId,
//       };

//       // Prepare the request body (audio_url)
//       const requestBody = { audio_url };

//       // Use the makeRequest function for the POST request
//       return await makeRequest(
//         "get_audio_response_post", // endpoint
//         requestParams, // query params
//         "post", // method
//         requestBody // data (body)
//       );
//     } catch (error) {
//       console.error("Error in getCallAUDIO:", error);
//       throw error;
//     }
//   }
// };

export const getCustomerUiUser = async (emailId, currentSessionId, email) => {
  const requestParams = {
    emailId,
    currentSessionId,
  };
  if (email) {
    requestParams.email = email;
  }
  try {
    return await makeRequest("get_customer_ui_user", requestParams);
  } catch (error) {
    console.error("Error in getCustomerUiRbca:", error);
    throw error;
  }
};

export const addCustomerUiUser = async (
  requestData,
  emailId,
  currentSessionId
) => {
  try {
    // Construct request params
    const requestParams = {
      emailId,
      currentSessionId,
    };

    console.log("requestData", requestData);

    // Use the makeRequest function for the POST request
    return await makeRequest(
      "post_customer_ui_user", // endpoint
      requestParams, // query params
      "post", // method
      requestData // data (body)
    );
  } catch (error) {
    console.error("Error in addCustomerUiUser:", error);
    throw error;
  }
};

export const updateCustomerUiUser = async (
  requestData,
  emailId,
  currentSessionId,
  clinicName
) => {
  try {
    // Construct request params
    const requestParams = {
      emailId,
      currentSessionId,
      clinicName,
    };

    // Use the makeRequest function for the PUT request
    return await makeRequest(
      "update_customer_ui_user", // endpoint
      requestParams, // query params
      "put", // method
      requestData // data (body)
    );
  } catch (error) {
    console.error("Error in updateCustomerUiUser:", error);
    throw error;
  }
};

export const deleteCustomerUiUser = async (
  email,
  emailId,
  currentSessionId
) => {
  try {
    // Construct request params
    const requestParams = {
      emailId,
      currentSessionId,
      email,
    };

    // Use the makeRequest function for the DELETE request
    return await makeRequest(
      "delete_customer_ui_user", // endpoint
      requestParams, // query params
      "delete" // method
    );
  } catch (error) {
    console.error("Error in deleteCustomerUiUser:", error);
    throw error;
  }
};

// export const addQuestionsFormNewTask = async (
//   requestData,
//   emailId,
//   currentSessionId
// ) => {
//   try {
//     const encryptedData = encryptData(requestData)
//     const response = await axios({
//       method: "POST",
//       url: `${API_BASE_URL}/questions_form_new_task`,
//       data: encryptedData,
//       params: { emailId, currentSessionId },
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: BASIC_AUTH_HEADER,
//       },
//     });
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

export const addQuestionsFormNewTask = async (
  requestData,
  emailId,
  currentSessionId
) => {
  try {
    // Construct request params
    const requestParams = {
      emailId,
      currentSessionId,
    };

    // Make the request using the makeRequest function and encrypt the data
    return await makeRequest(
      "questions_form_new_task", // endpoint
      requestParams, // query params
      "post", // method
      requestData // data (this will be encrypted inside the makeRequest function)
    );
  } catch (error) {
    console.error("Error in addQuestionsFormNewTask:", error);
    throw error; // re-throw the error for higher-level handling
  }
};

export const getQuestionsFromTask = async (
  emailId,
  currentSessionId,
  taskID
) => {
  const requestParams = {
    emailId,
    currentSessionId,
  };
  if (taskID) {
    requestParams.taskID = taskID;
  }
  try {
    return await makeRequest("get_questions_forms_tasks", requestParams);
  } catch (error) {
    console.error("Error in getQuestionsFromTask:", error);
    throw error;
  }
};

export const getCommonQuestions = async (emailId, currentSessionId) => {
  const requestParams = {
    emailId,
    currentSessionId,
  };

  try {
    return await makeRequest("get_common_questions", requestParams);
  } catch (error) {
    console.error("Error in get_common_questions:", error);
    throw error;
  }
};

export const getQuestionsForPage2 = async (
  emailId,
  currentSessionId,
  task_id,
  created_date
) => {
  const requestParams = {
    emailId,
    currentSessionId,
    created_date,
  };
  if (task_id) {
    requestParams.task_id = task_id;
  }
  try {
    return await makeRequest("get_questions_forms_task_data", requestParams);
  } catch (error) {
    console.error("Error in get_questions_forms_task_data:", error);
    throw error;
  }
};

export const completeQuestionReview = async (
  requestData,
  emailId,
  currentSessionId,
  task_id
) => {
  try {
    // Construct request params
    const requestParams = {
      emailId,
      currentSessionId,
      task_id,
    };

    // Use the makeRequest function for the POST request
    return await makeRequest(
      "questions_form_operation", // endpoint
      requestParams, // query params
      "post", // method
      requestData // data (encrypted inside makeRequest)
    );
  } catch (error) {
    console.error("Error in completeQuestionReview:", error);
    throw error;
  }
};

export const getAnalyticData = async (start_date, end_date) => {
  try {
    // Construct request params
    const requestParams = {
      currentSessionId: sessionStorage.getItem("sessionId"),
      emailId: sessionStorage.getItem("mail"),
      start_date,
      end_date,
    };

    // Make the request using the makeRequest function
    return await makeRequest(
      "get_analytics", // endpoint
      requestParams, // query params
      "get" // method
    );
  } catch (error) {
    console.error("Error in getAnalyticData:", error);
    throw error; // re-throw the error for higher-level handling
  }
};

export const createPaymentIntent = async (
  price,
  productId,
  currentSessionId,
  emailId,
  description
) => {
  try {
    // Use the makeRequest function to create a payment intent
    return await makeRequest(
      "create-payment-intent",
      { currentSessionId, emailId }, // Include emailId in the request
      "post",
      {
        amount: price,
        productId: productId,
        customerEmail: emailId,
        description: description,
      } // Pass the items directly
    );
  } catch (error) {
    console.error("Error creating payment intent:", error);
    throw error; // Re-throw the error for higher-level handling
  }
};

export const createSubscription = async (
  customerId,
  priceId,
  emailId,
  sessionId
) => {
  try {
    // Construct the request parameters
    const requestParams = {
      customerId,
      priceId,
      emailId, // Include email ID
      sessionId, // Include session ID
    };

    // Use the makeRequest function to create a subscription
    return await makeRequest(
      "create-subscription", // endpoint
      requestParams, // query params
      "post" // method
    );
  } catch (error) {
    console.error("Error creating subscription:", error);
    throw error; // Rethrow the error for handling in the calling function
  }
};

export const getAccountDetails = async () => {
  try {
    return await makeRequest(
      "get-account-details",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "get"
    );
  } catch (error) {
    console.error("Error in getCustomerPayments:", error);
    throw error; // Re-throw the error for higher-level handling
  }
};
export const getCustomerPayments = async () => {
  try {
    return await makeRequest(
      "list-payment-methods",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "post",
      { customer_id: "cus_RgIMOesQiAmUlv" } // Adjust as necessary
    );
  } catch (error) {
    console.error("Error in getCustomerPayments:", error);
    throw error; // Re-throw the error for higher-level handling
  }
};

export const checkRemainingCalls = async ({
  numberOfCalls = 0,
  justCheck = false,
  notify = false,
  currentSessionId = sessionStorage.getItem("sessionId"),
  emailId = sessionStorage.getItem("mail"),
  providerEmail = sessionStorage.getItem("providerEmail"),
}) => {
  try {
    return await makeRequest(
      "check_remaing_call",
      {
        calls: numberOfCalls,
        just_check: justCheck,
        notify,
        currentSessionId,
        emailId,
        provider_email: providerEmail,
        // stripe_customer_id: stripeCustomerId,
      },
      "get"
    );
  } catch (error) {
    console.error("Error in checkRemainingCalls:", error);
    throw error;
  }
};

export const createPaymentRecord = async (paymentDetails) => {
  try {
    return await makeRequest(
      "create-payment-record",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "post",
      paymentDetails
    );
  } catch (error) {
    console.error("Error in createPaymentRecord:", error);
    throw error;
  }
};

export const changeDefaultPaymentMethod = async (cardDetails) => {
  try {
    return await makeRequest(
      "set-default-payment-method",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "post",
      cardDetails
    );
  } catch (error) {
    console.error("Error in createPaymentRecord:", error);
    throw error; // Re-throw for higher-level handling
  }
};

export async function attachPaymentMethod(paymentMethodId) {
  try {
    const response = await makeRequest("attach-payment-method", {}, "post", {
      paymentMethodId,
    });
    return response;
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function attachNewPaymentMethod(paymentMethodId) {
  try {
    return await makeRequest("attach-payment-method", {}, "post", {
      payment_method_id: paymentMethodId,
    });
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function makeTransaction(paymentMethodId, amount, productId) {
  try {
    return await makeRequest("make-transaction", {}, "post", {
      amount: amount,
      payment_method_id: paymentMethodId,
      product_id: productId
    });
  } catch (error) {
    console.error("Error in makeTransaction:", error);
    throw error;
  }
}

export async function clearDue(paymentMethodId, amount, units) {
  try {
    return await makeRequest("clear-due", {}, "post", {
      amount: amount,
      payment_method_id: paymentMethodId,
      units,
    });
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function getPaymentsList() {
  try {
    const requestParams = {
      emailId: sessionStorage.getItem("mail"),
      currentSessionId: sessionStorage.getItem("sessionId"),
    };

    return await makeRequest("get-all-payments", requestParams, "get");
  } catch (error) {
    console.error("Error in getPaymentsList:", error);
    throw error;
  }
}

export async function authenticateUser({ email, password }) {
  try {
    return await makeRequest(
      "authenticate",
      {},
      "post",
      { email, password },
      true
    );
  } catch (error) {
    console.error("Error in getPaymentsList:", error);
    throw error;
  }
}

export async function updateUserPassword(newPassword) {
  try {
    return await makeRequest("update-password", {}, "post", {
      idToken: sessionStorage.getItem("idToken"),
      newPassword,
    });
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function passwordResetEmail(email) {
  try {
    return await makeRequest("password-reset-email", {}, "post", {
      email,
    }, true);
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function createUserWithEmailAndPassword(email, password) {
  try {
    return await makeRequest(
      "create-user",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "post",
      {
        email,
        password,
      }
    );
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function checkPassword(idToken) {
  if (!idToken) return;
  try {
    return await makeRequest(
      "cipher-inspect",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "post",
      { idToken },
      true
    );
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function syncVault() {
  try {
    const queryParams = {
      currentSessionId: sessionStorage.getItem("sessionId"),
      emailId: sessionStorage.getItem("mail"),
    };

    const queryString = Object.keys(queryParams)
      .map((key) => {
        if (Array.isArray(queryParams[key])) {
          // If the value is an array, join its elements using commas
          return `${key}=${queryParams[key].join(",")}`;
        } else {
          return `${key}=${encodeURIComponent(queryParams[key])}`;
        }
      })
      .join("&");

    const url = `${API_BASE_URL}/vault-sync?${queryString}`;

    return axios.request({
      method: "get",
      url,
      headers: {
        Authorization: sessionStorage.getItem("BasicToken"),
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error("Error in getPaymentsList:", error);
    throw error;
  }
}

export async function getPaymentDocById(paymentId) {
  try {
    return await makeRequest(
      "get-payment-doc",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "post",
      { payment_id: paymentId }
    );
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export async function getStripeInvoiceURL(transactionId) {
  try {
    return await makeRequest(
      "download-stripe-invoice",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
        transactionId,
      },
      "get",
      null,
      true
    );
  } catch (error) {
    console.error("Error in attachPaymentMethod:", error);
    throw error;
  }
}

export const sendEmail = async (
  toEmails,
  subject,
  htmlContent
) => {
  try {
    // Construct query parameters (if your backend expects them)
    const queryParams = {
      currentSessionId: sessionStorage.getItem("sessionId"),
      emailId: sessionStorage.getItem("mail"),
    };

    // Construct the request body without from_email
    const requestBody = {
      to_emails: toEmails,
      subject: subject,
      html_content: htmlContent,
    };

    // Call the generic makeRequest function to invoke the send-email endpoint.
    return await makeRequest("send-email", queryParams, 'post', requestBody, );
  } catch (error) {
    console.error("Error sending email:", error);
    throw error;
  }
};

export const getUsecaseStructure = async () => {
  try {
    return await makeRequest(
      "get_account_usecase_structure",
      {
        emailId: sessionStorage.getItem("mail"),
        currentSessionId: sessionStorage.getItem("sessionId"),
      },
      "get"
    );
  } catch (error) {
    console.error("Error in getUsecaseStructure:", error);
    throw error;
  }
};

export const validatePatientData = async (requestPayload, emailId, currentSessionId, path) => {
  try {
    // Construct request params with default usecase
    const requestParams = {
      emailId,
      currentSessionId,
      path
      // usecaseName: "benefitsVerification"  // Setting default usecase
    };

    // Make the request using makeRequest function
    return await makeRequest(
      "validate_patient_data",
      requestParams,
      "post",
      requestPayload,
      true
    );
  } catch (error) {
    console.error("Error in validatePatientData:", error);
    throw error;
  }
};

export const getProducts = async () => {
  try {
    return await makeRequest(
      "get-products",
      {
        currentSessionId: sessionStorage.getItem("sessionId"),
        emailId: sessionStorage.getItem("mail"),
      },
      "get"
    );
  } catch (error) {
    console.error("Error in getProducts:", error);
    throw error;
  }
};

export const createCustomQuestions = async (path, questions) => {
  try {
    return await makeRequest(
      "create-custom-questions",
      {
        emailId: sessionStorage.getItem("mail"),
        currentSessionId: sessionStorage.getItem("sessionId"),
      },
      "post",
      {
        path,
        questions
      },
      true
    );
  } catch (error) {
    console.error("Error in createCustomQuestions:", error);
    throw error;
  }
};

export const validateCustomQuestions = async (questions, branch, usecase, subusecase) => {
  try {
    return await makeRequest(
      "validate-custom-questions",
      {
        emailId: sessionStorage.getItem("mail"),
        currentSessionId: sessionStorage.getItem("sessionId"),
      },
      "post",
      {
        questions,
        branch,
        usecase,
        subusecase
      },
      true
    );
  } catch (error) {
    console.error("Error in validateCustomQuestions:", error);
    throw error;
  }
};

export const getQuestionsByPath = async (path) => {
  try {
    return await makeRequest(
      "get_questions_by_path",
      {
        emailId: sessionStorage.getItem("mail"),
        currentSessionId: sessionStorage.getItem("sessionId"),
      },
      "post",
      { path },
      true // bypassEncryption: send request body as plain JSON
    );
  } catch (error) {
    console.error("Error in getQuestionsByPath:", error);
    throw error;
  }
};

/**
 * Creates a new facility.
 * @param {Object} facilityData - The facility data to create (see API docs for structure)
 * @returns {Promise<Object>} The created facility response
 */
export const createFacility = async (facilityData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/v1/facilities`, facilityData, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in createFacility:", error);
    throw error;
  }
};

/**
 * Fetches all facilities.
 * @returns {Promise<Array>} List of facilities
 */
export const getFacilities = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/v1/facilities`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data.response;
  } catch (error) {
    console.error("Error in getFacilities:", error);
    throw error;
  }
};

/**
 * Updates an existing facility.
 * @param {string} id - The facility ID
 * @param {Object} facilityData - The updated facility data
 * @returns {Promise<Object>} The updated facility response
 */
export const editFacility = async (id, facilityData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/api/v1/facilities/${id}`, facilityData, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in editFacility:", error);
    throw error;
  }
};


